// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"32e4b82a","239":"24258c12","453":"10d8d359","732":"1e84237b"}[chunkId] + ".chunk.js";
};